import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "Comment fonctionne Coway ?",
        a: "Coway met en relation des voyageurs qui prennent un taxi, VTC ou Uber dans la même direction au même moment. Vous indiquez votre trajet, l'application vous propose des passagers compatibles, vous montez ensemble et organisez librement le partage des frais entre vous. Coway ne gère aucun aspect financier.",
    },
    {
        q: "Coway est-il gratuit ?",
        a: "Oui, Coway est 100% gratuit. L'application est uniquement une plateforme de mise en relation : aucune commission, aucun encaissement, aucun paiement à effectuer dans l'application. Vous réglez votre part directement entre passagers, comme bon vous semble.",
    },
    {
        q: "Comment partager un trajet ?",
        a: "Rien de plus simple : indiquez votre point de départ, votre destination et l'horaire souhaité. Coway vous propose immédiatement les passagers vérifiés qui vont dans la même direction. Vous choisissez, vous échangez, vous partagez.",
    },
    {
        q: "Les profils sont-ils vérifiés ?",
        a: "Oui. Chaque utilisateur Coway passe une vérification d'identité, de numéro de téléphone et de photo de profil. Vous savez toujours avec qui vous voyagez.",
    },
    {
        q: "Puis-je discuter avant le trajet ?",
        a: "Bien sûr. Une messagerie sécurisée est intégrée dans l'application pour échanger avec votre Coway avant le trajet. Aucun numéro de téléphone n'est partagé.",
    },
    {
        q: "Comment supprimer mon compte ?",
        a: "Vous pouvez supprimer votre compte directement depuis l'application (Paramètres > Compte > Supprimer mon compte) ou via la page dédiée /delete-account sur ce site. La suppression est définitive sous 30 jours.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-24 lg:py-32"
        >
            <div className="max-w-3xl mx-auto px-6 lg:px-8">
                <div className="text-center mb-14">
                    <p className="text-xs text-coway uppercase tracking-[0.3em] font-semibold mb-5">
                        FAQ
                    </p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-slate-900">
                        Vos questions,
                        <br />
                        <span className="text-slate-400">nos réponses.</span>
                    </h2>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <Accordion
                        type="single"
                        collapsible
                        className="w-full space-y-3"
                        data-testid="faq-accordion"
                    >
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i + 1}`}
                                data-testid={`faq-item-${i + 1}`}
                                className="bg-white border border-slate-200 rounded-2xl px-6 py-1 hover:border-coway/40 transition-colors card-elevated"
                            >
                                <AccordionTrigger className="text-left text-base lg:text-lg font-semibold text-slate-900 hover:text-coway py-5 hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-base">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>

                <div className="mt-12 text-center">
                    <p className="text-slate-500 text-sm">
                        Une autre question ?{" "}
                        <a
                            href="mailto:cowayfrance@gmail.com"
                            className="text-coway hover:underline font-medium"
                            data-testid="faq-contact-link"
                        >
                            cowayfrance@gmail.com
                        </a>
                    </p>
                </div>
            </div>
        </section>
    );
}
